import ValuerAmendFieldListHandler from "./ValuerAmendFieldListHandler";
import {useEffect} from "react";


const ValuerAmendValueDependantField = (props) => {

    // For Saving
    const summaryId = props.summaryId
    const section = props.sectionName
    const values = props.values

    const GetValueFromGrandParentValues = props.GetValueFromGrandParentValues
    const valueDependantFields = props.valueDependantFields ? props.valueDependantFields : []

    // Saving Tracker
    const UpdateParentValue = props.UpdateParentValue
    const AddToQueue = props.AddToQueue
    const RemoveFromQueue = props.RemoveFromQueue
    const AddToErroredSaves = props.AddToErroredSaves

    // Error Handling
    const setErrorMessage = props.setErrorMessage
    const setErrorTitle = props.setErrorTitle

    useEffect(() => {

    }, [])

    return (
        <>
            {valueDependantFields && valueDependantFields.map((fields) => {
                return (
                    <>
                        {GetValueFromGrandParentValues(fields.dependantField) && (fields.requirement && GetValueFromGrandParentValues(fields.dependantField) === fields.requirement.value)
                        || GetValueFromGrandParentValues(fields.dependantField) && (fields.antiRequirement && GetValueFromGrandParentValues(fields.dependantField) !== fields.antiRequirement.value)
                            ? <ValuerAmendFieldListHandler fieldList={fields.fields}
                                                           values={values}
                                                           sectionName={section}
                                                           summaryId={summaryId}
                                                           setErrorMessage={setErrorMessage}
                                                           setErrorTitle={setErrorTitle}
                                                           UpdateParentValue={UpdateParentValue}
                                                           AddToQueue={AddToQueue}
                                                           RemoveFromQueue={RemoveFromQueue}
                                                           AddToErroredSaves={AddToErroredSaves}/>
                            : null
                        }
                    </>
                )
            })}
        </>
    )
}

export default ValuerAmendValueDependantField;